import { Injectable } from "@angular/core";

export const daforScores = ['rare_0_1_10', 'occasional_10_25', 'frequent_25_33', 'abundant_33_50', 'dominant_50'] as const;
export type DaforScore = typeof daforScores[number];
export const dominScores = ['+', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'] as const;
export type DominScore = typeof dominScores[number];

export const dafor: Record<DaforScore, string> = {
  'rare_0_1_10': 'Rare (0.1 - 10%)',
  'occasional_10_25': 'Occasional (10 - 25%)',
  'frequent_25_33': 'Frequent (25 - 33%)',
  'abundant_33_50': 'Abundant (33 - 50%)',
  'dominant_50': 'Dominant (>50%)',
};

export const domin: Record<DominScore, string> = {
  '+': '+ (<1%)',
  '1': '1 (<1%)',
  '2': '2 (<1%)',
  '3': '3 (1-4%)',
  '4': '4 (5-10%)',
  '5': '5 (11-25%)',
  '6': '6 (26-33%)',
  '7': '7 (34-50%)',
  '8': '8 (51-75%)',
  '9': '9 (76-90%)',
  '10': '10 (91-100%)',
};


@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  getDafor(score: DaforScore) {
    return dafor[score];
  }
  getDomin(score: DominScore) {
    return domin[score];
  }
}
